import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  Alert,
  Spinner,
  CardTitle,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import ExpenseHeader from "../ExpenseDashboard/ExpenseHeader";
// import Header from "./Header";

const AddProject = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState({ name: "", description: "" });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ message: "", type: "" });

  const API_URL = "https://api.hanoch.in/expense/project_categories/";

  // 🔹 Fetch all categories from backend
  const fetchProjects = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_URL);
      console.log("result",res.data)
      setProjects(res.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setLoading(false);
    }
  };

  // 🔹 Handle input changes
  const handleChange = (e) => {
    setProject({ ...project, [e.target.name]: e.target.value });
  };

  // 🔹 Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!project.name || !project.description) {
      setAlert({ message: "Please fill all fields", type: "danger" });
      return;
    }

    try {
      await axios.post(API_URL, project);
      setAlert({ message: "Project added successfully!", type: "success" });
      setProject({ name: "", description: "" });
      fetchProjects(); // refresh list
    } catch (error) {
      console.error("Error adding project:", error);
      setAlert({ message: "Failed to add project", type: "danger" });
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  return (
    <>
      <ExpenseHeader/>
      <Container className="mt-4">
      

        {/* 🔔 Alert Messages */}
        {alert.message && (
          <Alert
            color={alert.type}
            toggle={() => setAlert({ message: "", type: "" })}
          >
            {alert.message}
          </Alert>
        )}

        {/* 🧾 Add Category Form */}
        <Card className="mb-4 shadow-sm">
          <CardTitle  tag="h6"className="p-2"><h4 className="text-info">Add Project </h4></CardTitle>
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Project Name</Label>
                    <Input
                      type="text"
                      name="name"
                      value={project.name}
                      onChange={handleChange}
                      placeholder="Enter project name"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Project Description</Label>
                    <Input
                      type="text"
                      name="description"
                      value={project.description}
                      onChange={handleChange}
                      placeholder="Enter project description"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Button color="primary" type="submit">
                Add Project
              </Button>
            </Form>
          </CardBody>
        </Card>

        {/* 📋 Category List */}
        <Card className="shadow-sm">
          <CardHeader>Existing Projects</CardHeader>
          <CardBody>
            {loading ? (
              <div className="text-center my-4">
                <Spinner color="primary" />
              </div>
            ) : (
              <Table bordered responsive hover>
                <thead className="table-light">
                  <tr>
                   
                    <th>Name</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {projects.map((cat) => (
                    <tr key={cat.id}>
                   
                      <td>{cat.name}</td>
                      <td>{cat.description}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            
                )
            }
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default AddProject;
